import { AxiosResponse } from 'axios';

const HamsConcurrentProcessErrorKeys = ['CART_INVALID', 'MISSING_EXTERNAL_UUID'];
export const isHamsConcurrencyError = (result: AxiosResponse): boolean =>
  HamsConcurrentProcessErrorKeys.includes(result?.data?.errorKey);
